export const rollbarIgnoredMessages = [
  'Script error.', // https://docs.rollbar.com/docs/unknown-script-error
  'SetEvent is not defined',
  'OnSceneLoad is not defined',
]
